import { createContext, FC, useState } from 'react';

import { useTranslation } from '@crehana/i18n';

import { getTitle } from '../constants';

type TInteraction = string | null | undefined;
interface IFormStepsContext {
  setStep: (step: number) => void;
  setUserInteraction: (interaction: TInteraction) => void;
  setNameUser: (name: string) => void;
  nameUser: string;
  titleByStep: {
    title: string;
    subTitle: TInteraction;
  };
}
const defaultContext = {
  setStep: () => {},
  setNameUser: () => {},
  nameUser: '',
  setUserInteraction: () => {},
  titleByStep: {
    title: '',
    subTitle: '',
  },
};

export const FormStepsContext =
  createContext<IFormStepsContext>(defaultContext);

const FormStepsContextProvider: FC<React.PropsWithChildren> = ({
  children,
}) => {
  const [currentStep, setCurrentStep] = useState<number>(0);
  const [userInteraction, setUserInteraction] = useState<TInteraction>('');
  const [nameUser, setNameUser] = useState('');
  const { t } = useTranslation();

  const setStep = (step: number) => {
    setCurrentStep(step);
  };

  let titleByStep = getTitle(userInteraction, currentStep);

  titleByStep = { title: t(titleByStep.title), subTitle: titleByStep.subTitle };

  return (
    <FormStepsContext.Provider
      value={{
        setStep,
        titleByStep,
        setUserInteraction,
        setNameUser,
        nameUser,
      }}
    >
      {children}
    </FormStepsContext.Provider>
  );
};

export default FormStepsContextProvider;
